<div class="container">


    <div *ngIf="notifyInfo.status == NotificationStatus.SectionApplication_Ineligible" class='ineligibleMbrShp'>

        <h3>Unfortunately, it looks like you are not eligible for section membership.</h3>
        <div class="row">
            <div class="col-md-12">
                <p>Please <a [routerLink]="['/']">renew</a> your ACEP Membership to proceed further.
                </p>

                <p>If, after reading this, you believe there has been a mistake, please contact someone on ACEP's
                    Member Care team at <a href="email:membership@acep.org">membership@acep.org</a> or (888)
                    817-2237.
                </p>
            </div>
        </div>

    </div>

    <div *ngIf="notifyInfo.status == NotificationStatus.SectionApplication_Comp">
        <h3>Below sections have been added to your account for free.</h3>
        <div class="row">
            <div class="col-md-12">
                <p [innerHtml]="getCompSections()">
                </p>
            </div>
        </div>
        <div class="row">
            <div class="pull-right">
                <button mat-raised-button color="primary" (click)='goBackSectionApp()'>Back</button>
            </div>
        </div>
    </div>



    <div
        *ngIf="notifyInfo.status == NotificationStatus.Error || notifyInfo.status == NotificationStatus.Ineligible; else membershipNotifications">

        <div *ngIf="notifyInfo.status == NotificationStatus.Error">
            <h3>Server Error</h3>
            <div class="row">
                <div class="col-md-12">
                    <p>
                        A technical error has occurred while performing the current operation. Please contact our Member
                        Care Center at membership@acep.org or phone (888) 817-2237
                    </p>
                </div>
            </div>
        </div>



        <div *ngIf="notifyInfo.status == NotificationStatus.Ineligible" class='ineligibleMbrShp'>
            <!-- <h3>Sorry, you are not qualified.</h3>
            <div class="row">
                <div class="col-md-12">
                    <p>
                        Thank you for your interest in ACEP membership. According to the ACEP Bylaws, the requirements for regular membership are as follows:
                    </p>
                    <p [innerHtml]="getContentSnippet('BYLAWS')"></p>
                    <p>
                        Unfortunately, it appears you may not meet the requirements for membership. If you feel you have received this message in error, please contact our Member Care Center at membership@acep.org or phone (888) 817-2237.
                    </p>
                </div>
			</div> -->
            <h3>Unfortunately, it looks like you are not eligible for membership.</h3>
            <div class="row">
                <div class="col-md-12">
                    <p>We appreciate your interest in joining ACEP; however, according to the ACEP Bylaws, a regular
                        member must meet the following criteria:</p>
                    <ol>
                        <li>Satisfactory completion of an emergency medicine residency program accredited by the
                            Accreditation Council of Graduate Medical Education (ACGME) or the American Osteopathic
                            Association (AOA);</li>
                        <li>Satisfactory completion of an emergency medicine residency program approved by an ACEP
                            recognized accrediting body in a foreign country; </li>
                        <li>Satisfactory completion of a subspecialty training program in pediatric emergency medicine
                            accredited by the ACGME;</li>
                        <li>Primary board certification by an emergency medicine certifying body recognized by ACEP;
                        </li>
                        <li>Eligibility for active membership in the College (as defined by the college bylaws then in
                            force) at any time prior to close of business December 31, 1999.</li>
                    </ol>
                    <p>If, after reading this, you believe there has been a mistake, please contact someone on ACEP's
                        Member Care team at <a href="email:membership@acep.org">membership@acep.org</a> or (888)
                        817-2237.
                    </p>
                </div>

                <div class="row">
                    <div class="pull-right">
                        <button mat-raised-button color="primary" (click)='goBack()'>Back</button>
                    </div>
                </div>

            </div>



        </div>




    </div>


    <ng-template #membershipNotifications>
        <!---NewMembershipSuccessful | RenewalSuccesful-->
        <div
            *ngIf="notifyInfo.status == NotificationStatus.RenewalSuccesful || notifyInfo.status == NotificationStatus.NewMembershipSuccessful">


            <div class="row">
                <div class="col-lg-12">
                    <h2 class="font-body color-body">
                        <span class="fa-stack fa-lg fa-2x">
                            <i class="color-green fa fa-circle fa-stack-2x fa-background"></i>
                            <i class="fa fa-check fa-stack-1x fa-inverse"></i>
                        </span>Thank You
                        <br>
                        <div class='subtext'>Your membership {{notifyInfo.status ==
                            NotificationStatus.NewMembershipSuccessful ? 'application' : 'renewal request'}} is being
                            processed.
                            <!-- {{paymentInfo.InstallmentType != InstallmentType.Annual ? 'The amount shown reflects the amount of each installment payment.' : ''}} -->
                        </div>
                    </h2>
                    <p *ngIf="!groupPortalMode"> We sent a confirmation email to {{memberAppData.personalInfo.email}}
                    </p>
                    <ng-container *ngTemplateOutlet="orderDetails"></ng-container>
                    <!-- <p *ngIf="ORG=='ACEP'" [innerHtml]="getContentSnippet('MEMBERAPPLICATION_ORDERSUCCESSFUL_ACEP')"></p>
										<p *ngIf="ORG=='EMRA'" [innerHtml]="getContentSnippet('MEMBERAPPLICATION_ORDERSUCCESSFUL_EMRA')"></p> -->
                </div>
            </div>
            <div class="row margin-top-20">
                <div class="col-lg-12">
                    <button type="button" class="btn btn-print btn-outline" mat-raised-button="mat-raised-button"
                        (click)="printReceipt()" *ngIf="!groupPortalMode">
                        <i class="fa fa-1x fa-print" aria-hidden="true">&nbsp;&nbsp;</i>Print Receipt</button>

                    <button *ngIf="ORG != 'ACEP'" class="btn btn-advance pull-right" color="primary"
                        mat-raised-button="mat-raised-button" (click)="backToOrg()">Back to {{ORG}}.org</button>
                    <button *ngIf="ORG == 'ACEP'" class="btn btn-advance pull-right" color="primary"
                        mat-raised-button="mat-raised-button" (click)="gotToCustomizeMembership()">Customize
                        Membership</button>
                    <!-- *ngIf="ORG != 'ACEP'" -->
                    <!-- <button class="btn btn-outline btn-advance pull-right" color="primary" mat-raised-button="mat-raised-button" (click)="backToOrg()">Back to {{ORG}}.org</button> -->
                    <!-- <button *ngIf="ORG == 'ACEP'" class="pull-right" color="primary" mat-raised-button="mat-raised-button" (click)="gotToCustomizeMembership()">Customize Membership</button> -->

                </div>
            </div>

        </div>
        <!--AutoRenewalActive-->
        <div *ngIf="notifyInfo.status == NotificationStatus.AutoRenewalActive">
            <ng-container *ngTemplateOutlet="pageTitle"></ng-container>
            <p class="intro ctr">
                Thank you for your continued membership in ACEP. Your membership auto renews on
                {{notifyInfo.expirationdate}}. ACEP sends a confirmation notice to you approximately two weeks before
                your credit card is charged. If you would like to adjust your payment
                options, please contact the Member Care Center at (888) 817-2237.
            </p>
        </div>
        <!--NotReadyForRenewal-->
        <div *ngIf="notifyInfo.status == NotificationStatus.NotReadyForRenewal">
            <ng-container *ngTemplateOutlet="pageTitle"></ng-container>
            <p class="intro ctr">Your membership is valid through {{notifyInfo.expirationdate}} and renewal is not
                needed at this time. </p>



        </div>
        <!--ReadyToRestart-->
        <div *ngIf="notifyInfo.status == NotificationStatus.ReadyToRestart">
            <p class="intro ctr">Your membership had been previously cancelled as the payment was not been received for
                your application. Please click
                <a>here</a> to restart your membership application
            </p>
        </div>

        <ng-container *ngTemplateOutlet="invoices"></ng-container>

    </ng-template>






    <ng-template #pageTitle>
        <!-- <h1>Membership Renewal</h1>
		<div class="row">
			<div class="col-md-12">
				<div class="section-user">
					<div class="user-thumb">
						<img class="userImg" src="./assets/images/icon_images/profile_icon.png" />
					</div>
					<div class="user-info">
						<div class="username">Saletoday | Ima, ON</div>
						<div class="expireTime">Membership Expiring in 21 Days</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<h3 class="dark">Did You Know ACEP is the only emergency medicine organization...</h3>
			</div>
		</div>
		<div class="row row-eq-height">
			<div class="col-md-12">
				<div class="dyk-points">
					<div class="dyk-point dykp1">
						<div class="dykp-icon">
							<img class="dykp-icon-voice" src="./assets/images/icon_images/1_voice.svg" />
						</div>
						<div class="dykp-text">
							<p>With full-time staff in Washington D.C. to give emergency physicians a strong and unified voice on the issues that matter most to you and your patients.</p>
						</div>
					</div>
					<div class="dyk-point dykp2">
						<div class="dykp-icon">
							<img class="dykp-icon-database" src="./assets/images/icon_images/2_database.svg" />
						</div>
						<div class="dykp-text">
							<p>That provides a specialty-wide emergency medicine registry so you can quickly and easily meet your Quality obligations to be in compliance?</p>
						</div>
					</div>
					<div class="dyk-point dykp3">
						<div class="dykp-icon">
							<img class="dykp-icon-money" src="./assets/images/icon_images/3_money.svg" />
						</div>
						<div class="dykp-text">
							<p>That has a seat on the RUC, the body that sets CMS rates that determine how much goes in your wallet?</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row btnRow">
			<div class="col-md-12">
				<div class="col-md-3 pull-left mbrsh-remind">
					<button class="btn greyBtn">Remind Me Later</button>
				</div>
				<div class="col-md-3 pull-right mbrsh-renew">
					<button class="btn btnSavePrimary">Renew Membership</button>
				</div>
			</div>
		</div> -->
        <!-- <div class="row btnRow">
			<div class="col-xs-12">
				<p>For questions or concerns, please call us at (888) 817-2237, or email us at <a href="mailto:membership@acep.org">membership@acep.org</a></p>
			</div>
		</div> -->
    </ng-template>


    <ng-template #invoices>
        <p class="intro ctr">
            <br>Please view all your invoices
            <a target="_blank" href="../membership/dashboard/#/transactions">here</a>. For questions or concerns, please
            call us at (888) 817-2237, or email us at
            <a href="mailto:membership@acep.org">membership@acep.org</a>
        </p>

        <!-- <h1>Membership Renewal</h1>
		<div class="row">
			<div class="col-md-12">
				<div class="section-user">
					<div class="user-thumb">
						<img class="userImg" src="./assets/images/icon_images/profile_icon.png" />
					</div>
					<div class="user-info">
						<div class="username">Saletoday | Ima, ON</div>
						<div class="expireTime">Membership Expiring in 21 Days</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12">
				<h3 class="dark">Did You Know ACEP is the only emergency medicine organization...</h3>
			</div>
		</div>
		<div class="row row-eq-height">
			<div class="col-md-12">
				<div class="dyk-points">
					<div class="dyk-point dykp1">
						<div class="dykp-icon">
							<img class="dykp-icon-voice" src="./assets/images/icon_images/1_voice.svg" />
						</div>
						<div class="dykp-text">
							<p>With full-time staff in Washington D.C. to give emergency physicians a strong and unified voice on the issues that matter most to you and your patients.</p>
						</div>
					</div>
					<div class="dyk-point dykp2">
						<div class="dykp-icon">
							<img class="dykp-icon-database" src="./assets/images/icon_images/2_database.svg" />
						</div>
						<div class="dykp-text">
							<p>That provides a specialty-wide emergency medicine registry so you can quickly and easily meet your Quality obligations to be in compliance?</p>
						</div>
					</div>
					<div class="dyk-point dykp3">
						<div class="dykp-icon">
							<img class="dykp-icon-money" src="./assets/images/icon_images/3_money.svg" />
						</div>
						<div class="dykp-text">
							<p>That has a seat on the RUC, the body that sets CMS rates that determine how much goes in your wallet?</p>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="row btnRow">
			<div class="col-md-12">
				<div class="col-md-3 pull-left mbrsh-remind">
					<button class="btn greyBtn">Remind Me Later</button>
				</div>
				<div class="col-md-3 pull-right mbrsh-renew">
					<button class="btn btnSavePrimary">Renew Membership</button>
				</div>
			</div>
		</div> -->
    </ng-template>


    <ng-template #orderDetails>
        <table class="table table-sm ordertable" *ngIf="!groupPortalMode">
            <tbody>
                <tr>
                    <td>Order Number</td>
                    <td>{{notifyInfo.orderNumber}}</td>
                </tr>
                <tr>
                    <td>Amount</td>
                    <td>{{paymentInfo.Amount | currency:'USD':'symbol-narrow':'1.2-2'}}

                    </td>
                </tr>
                <tr *ngIf="paymentInfo.AutoRenewal == 'true'">
                    <td>Auto Renewal</td>
                    <td>Yes</td>
                </tr>
                <tr>
                    <td>Payment Type</td>
                    <td>
                        <div *ngIf="paymentInfo.PaymentType == PaymentType.Check">
                            Check
                        </div>

                        <div *ngIf="paymentInfo.PaymentType == PaymentType.PayPal">
                            PayPal
                        </div>

                        <div class='no-BootstrapCtr checkoutCtr'
                            *ngIf="paymentInfo.PaymentType == PaymentType.CreditCard">
                            {{maskedCCNumber}}
                            <span class="sprites image-{{CardType[paymentInfo.CardType]}}"></span>
                        </div>

                        <div class='no-BootstrapCtr checkoutCtr' *ngIf="paymentInfo.PaymentType == PaymentType.ECP">
                            <img src="./assets/images/icon_images/ecp.png" class="ecpImg" alt="" /> {{maskedCCNumber}}
                        </div>

                    </td>

                </tr>
            </tbody>
        </table>

        <div class="alert alert-info" *ngIf="paymentInfo.PaymentType == PaymentType.Check">
            Please send a check or money order to:
            <br>
            <br> American College of Emergency Physicians
            <br> P.O. Box 619911
            <br> Dallas TX 75261-9911
            <br>
            <br>
            <i> Please write the ACEP ID
                <b class="bold">{{acepId}}</b> and
                <b>'{{ORG}} Membership Application Fee'</b> on your check.
            </i>
        </div>
    </ng-template>